import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type {
  IOffboardingDetails,
  IOffboardingPayload,
  IOffboardingListResponse,
  IOffboardingDetailsResponse,
} from "@/interface/offboarding.interface";

const OffboardingService = {
  // Initiate offboarding (Step 1)
  initiateOffboarding: async (
    userId: string,
    payload: IOffboardingDetails,
  ): Promise<IOffboardingDetailsResponse> => {
    const API = `${API_ENDPOINT.user}/${userId}/offboarding/initiate`;
    return callApi<IOffboardingDetailsResponse>(API, {
      method: "POST",
      data: payload,
    });
  },

  // Get offboarding details for a specific user
  getOffboardingDetails: async (
    userId: string,
  ): Promise<IOffboardingDetailsResponse> => {
    const API = `${API_ENDPOINT.user}/${userId}/offboarding`;
    return callApi<IOffboardingDetailsResponse>(API, {
      method: "GET",
    });
  },

  // Update offboarding clearance checklist (Steps 2 & 3)
  updateOffboarding: async (
    userId: string,
    payload: IOffboardingPayload,
  ): Promise<IOffboardingDetailsResponse> => {
    const API = `${API_ENDPOINT.user}/${userId}/offboarding/update`;
    return callApi<IOffboardingDetailsResponse>(API, {
      method: "PUT",
      data: payload,
    });
  },

  // Get the list of all offboarded/in-process employees
  getOffboardingList: async (
    params: string,
  ): Promise<IOffboardingListResponse> => {
    const API = `${API_ENDPOINT.user}/offboarding/list?${params ? params : ""}`;
    return callApi<IOffboardingListResponse>(API, {
      method: "GET",
      // params,
    });
  },

  // Download No Dues form report (Blob)
  downloadNoDuesReport: async (id: string): Promise<Blob> => {
    const API = `${API_ENDPOINT.report}/no-dues-form/download?userId=${id}`;
    return callApi<Blob>(API, {
      method: "GET",
    });
  },
};

export default OffboardingService;
